import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookADemo } from './Areas/BookADemo/BookADemo';
import { EnterpriseSuitability } from './Areas/EnterpriseSuitability/EnterpriseSuitability';
import { Intro } from './Areas/Intro/Intro';
import { LongTerm } from './Areas/LongTerm/LongTerm';
import { ModernCompatibility } from './Areas/ModernCompatibility/ModernCompatibility';
import { Organizations } from './Areas/Organizations/Organizations';
import { OurClients } from './Areas/OurClients/OurClients';
import { StyledEnterpriseLandingPage } from './EnterpriseLandingPage.styles';
import { MetaTags } from '@/shared/seo';

export const EnterpriseLandingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <MetaTags title="metatag.enterprise.title" description="metatag.enterprise.description" />
      <StyledEnterpriseLandingPage>
        <h1 className="u1st-sr-only">{t('landing_page.enterprise.main_heading')}</h1>
        <Intro />
        <EnterpriseSuitability />
        <ModernCompatibility />
        <OurClients />
        <Organizations />
        <LongTerm />
        <BookADemo />
      </StyledEnterpriseLandingPage>
    </>
  );
};
